import { DenouncedGeneral } from "../Model/DenouncedGeneral";
import { Query } from "../Model/Query";
import { Third } from "../Model/Third";
import { getCurrentUser } from "./session";
import { v4 as v4uuid } from "uuid";
export class DenouncedGeneralService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(thirdId, diligenceId) {
        if (diligenceId) {
            const response = await this.apiService.get('denounced_general/general/' + diligenceId + '/third_id/' + thirdId);
            if (!response.ok) {
                throw new Error(`Error al obtener`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener Id`);
        }
    }
    async findByDiligenceNumber(diligenceId) {
        if (diligenceId) {
            const response = await this.apiService.get('denounced_general/general/' + diligenceId);
            if (!response.ok) {
                throw new Error(`Error al obtener`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener Id`);
        }
    }
    async saveDenouncedGeneral(denounded) {
        if (denounded) {
            const response = await this.apiService.post('denounced_general/general/', denounded);
            if (!response.ok) {
                throw new Error(`Error al guardar el denunciado de Genero.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener  Genero.`);
        }
    }
    async findThirds(opts) {
        var _a, _b;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.diligenceId) {
                query.addFilter('diligence_id', [opts.filters.diligenceId]);
            }
            if ((_b = opts.filters) === null || _b === void 0 ? void 0 : _b.thirdId) {
                query.addFilter('third_id', [opts.filters.thirdId]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`denounced_general/generalThirds?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los terceros.`);
            }
            const content = await response.json();
            return content.map(third => new Third(third).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async createDenouncedGeneral(thirdId, diligenceId) {
        if (thirdId && diligenceId) {
            const third = new DenouncedGeneral({
                id: v4uuid(),
                diligenceNumber: diligenceId,
                denouncedThirId: thirdId,
                wantToDeclare: false,
                familyNotice: false,
                medicalExamination: false,
                interpreter: false,
                appointLawyer: false,
                publicDefender: false,
                optionalPart: " ",
                own_arms: false,
                arms_types: " ",
                meetWhistleblower: false,
                relationshipWithComplainant: false,
                userId: getCurrentUser().id,
            });
            const response = await this.apiService.post('denounced_general/general', third.getState());
            if (!response.ok) {
                throw new Error(`Error al guardar el denunciante de una diligencia trafico`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el denunciante`);
        }
    }
    async deleteDenouncedGeneral(thirdId) {
        if (thirdId) {
            const response = await this.apiService.post('denounced_general/delete', { id: thirdId });
            if (!response.ok) {
                throw new Error(`Error al eliminar el denunciado de una diligencia general.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el denunciado.`);
        }
    }
}
